import React, { createContext, useState, useEffect, useContext } from "react";

// Create Context
const FussstatusContext = createContext();

// Provider Component
export const FussstatusProvider = ({ children }) => {
  const [data, setData] = useState(() => {
    const saved = localStorage.getItem("fussstatus");
    if (saved) {
      const parsed = JSON.parse(saved);
      return { ...parsed };
    }
    // Default empty values for all fields
    return {
      // 1) Dialysepflichtige Niereninsuffienz
      dialysepflichtigeNiereninsuffienz: "",

      // 2) Drohende dorsale Ulcera
      linksDrohendeDorsaleUlcera: "",
      rechtsDrohendeDorsaleUlcera: "",

      // 3) Präulzerative Veränderungen
      linksPraeulzerativeVeranderungen: "",
      rechtsPraeulzerativeVeranderungen: "",

      // 4) Ulcus + Typ (optional)
      linksUlcus: "",
      rechtsUlcus: "",
      linksUlcusTyp: "",
      rechtsUlcusTyp: "",

      // 5) Zustand nach Zehenamputation
      linksZustandNachZehenamputation: "",
      rechtsZustandNachZehenamputation: "",

      // 6) Fußdeformitäten
      linksFussdeformitaeten: "",
      rechtsFussdeformitaeten: "",

      // 7) Dorsalextension OSG
      linksDorsalextensionOSG: "",
      rechtsDorsalextensionOSG: "",

      // 7.1) Extension Großzehengrundgelenk
      linksExtensionGrosszehengrundgelenk: "",
      rechtsExtensionGrosszehengrundgelenk: "",

      // 8) Hinweis auf CNO
      linksHinweisCNO: "",
      rechtsHinweisCNO: "",

      // 9) Zustand nach Amputation
      linksZustandNachAmputation: "",
      rechtsZustandNachAmputation: "",

      //Ulcusnotiz
      UlcusNotiz: "",

      //Toes
      linksZehenamputation: [],
      rechtsZehenamputation: [], 
    };
  });

  // Persist to localStorage on every data change
  useEffect(() => {
    const dataToSave = { ...data };
    localStorage.setItem("fussstatus", JSON.stringify(dataToSave));
  }, [data]);

  // Clear function – resets all fields and removes from localStorage
  const clearFussstatus = () => {
    setData({
      dialysepflichtigeNiereninsuffienz: "",
      linksDrohendeDorsaleUlcera: "",
      rechtsDrohendeDorsaleUlcera: "",
      linksPraeulzerativeVeranderungen: "",
      rechtsPraeulzerativeVeranderungen: "",
      linksUlcus: "",
      rechtsUlcus: "",
      linksUlcusTyp: "",
      rechtsUlcusTyp: "",
      linksZustandNachZehenamputation: "",
      rechtsZustandNachZehenamputation: "",
      linksFussdeformitaeten: "",
      rechtsFussdeformitaeten: "",
      linksDorsalextensionOSG: "",
      rechtsDorsalextensionOSG: "",
      linksExtensionGrosszehengrundgelenk: "",
      rechtsExtensionGrosszehengrundgelenk: "",
      linksHinweisCNO: "",
      rechtsHinweisCNO: "",
      linksZustandNachAmputation: "",
      rechtsZustandNachAmputation: "",
      UlcusNotiz: "",
      linksZehenamputation: [],
      rechtsZehenamputation: [], 
    });
    localStorage.removeItem("fussstatus");
  };

  return (
    <FussstatusContext.Provider
      value={{ data, setData, clearFussstatus }}
    >
      {children}
    </FussstatusContext.Provider>
  );
};

// Custom Hook
export const useFussstatus = () => {
  const context = useContext(FussstatusContext);
  if (!context) {
    throw new Error("useFussstatus must be used within FussstatusProvider");
  }
  return context;
};
